import './AddTeamMemberList.css';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Button from '../../Button/Button';
import { useGetProjectByIdQuery } from 'src/services';
import { useGetUsersAllQuery } from 'src/services/usersService';
import { Checkbox } from 'src/components/ui/checkbox';
import { Separator } from 'src/components/ui/separator';
import { Controller, useForm } from 'react-hook-form';

export const AddTeamMemberList = ({ onSubmit }) => {
  const { data: users } = useGetUsersAllQuery();
  const { id } = useParams();
  const { data: currentProject } = useGetProjectByIdQuery({ id: id });
  const [teamMembers, setTeamMembers] = useState([]);
  const { handleSubmit, control, watch } = useForm({
    defaultValues: {
      teamMembers: [],
    },
  });
  const teamMembersValue = watch('teamMembers');
  useEffect(() => {
    if (currentProject && users) {
      const members = users.filter((user) => {
        const userInProject = currentProject.team_members.find(
          (teamMember) => teamMember.user.id === user.id,
        );

        return !userInProject;
      });

      setTeamMembers(members);
    }
  }, [currentProject, users]);

  const submit = (data) => {
    if (!data.teamMembers.length) {
      return;
    }

    const request = {
      users: data.teamMembers,
    };

    onSubmit && onSubmit(request);
  };

  const onCheckedChange = (checked, onChange, teamMember) => {
    let value;

    if (checked) {
      value = [...teamMembersValue, teamMember.id];
    } else {
      value = teamMembersValue.filter((itemId) => itemId !== teamMember.id);
    }

    onChange(value);
  };

  return (
    <>
      <form id="add-team-member-list-form" onSubmit={handleSubmit(submit)}>
        <ul className={'add-team-member-list'}>
          <Controller
            control={control}
            name={'teamMembers'}
            render={({ field: { onChange, value } }) => {
              return (
                <>
                  {teamMembers.map((teamMember, index, array) => {
                    return (
                      <li className={'add-team-member-list-item'} key={teamMember.id}>
                        <label htmlFor={`${teamMember.id}-team-member`}>
                          <Checkbox
                            id={`${teamMember.id}-team-member`}
                            checked={value?.some((el) => el === teamMember.id)}
                            onCheckedChange={(checked) => {
                              onCheckedChange(checked, onChange, teamMember);
                            }}
                          />
                          <span className="text-base text-ebony opacity-50 cursor-pointer font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                            {`${teamMember.first_name} ${teamMember.last_name}`}
                          </span>
                        </label>
                        {index < array.length - 1 && <Separator />}
                      </li>
                    );
                  })}
                </>
              );
            }}
          />
        </ul>
        {/*<ul className={'add-team-member-list'}>*/}
        {/*  {teamMembers &&*/}
        {/*    teamMembers.map((teamMember) => {*/}
        {/*      return (*/}
        {/*        <li className={'add-team-member-list-item'} key={teamMember.id}>*/}
        {/*          <label*/}
        {/*            htmlFor={`${teamMember.id}-team-member`}*/}
        {/*            onClick={() => setSelected(teamMember.id)}*/}
        {/*          >*/}
        {/*            <input*/}
        {/*              name={'team-member'}*/}
        {/*              value={teamMember.id}*/}
        {/*              id={`${teamMember.id}-team-member`}*/}
        {/*              type="radio"*/}
        {/*            />*/}
        {/*            <p>{`${teamMember.first_name} ${teamMember.last_name}`}</p>*/}
        {/*          </label>*/}
        {/*        </li>*/}
        {/*      );*/}
        {/*    })}*/}
        {/*</ul>*/}

        <div className={'input-container buttons'}>
          <Button
            type="submit"
            form="add-team-member-list-form"
            className="green"
            disabled={!teamMembersValue.length}
          >
            Add User
          </Button>
        </div>
      </form>
    </>
  );
};
